import { getGroupId } from '@/components/chatbot/chatbotElementUtils';

function setGreetingView() {
  const expirationTime = new Date().getTime(); // one hour from now
  const groupId = getGroupId();
  const key = 'solvGreetingSeen' + groupId;
  window.localStorage.setItem(key, expirationTime);
}

function getGreetingView() {
  const groupId = getGroupId();
  const key = 'solvGreetingSeen' + groupId;
  return window.localStorage.getItem(key);
}

function setMinimization() {
  const expirationTime = new Date().getTime(); // one hour from now
  const groupId = getGroupId();
  const key = 'solvMinimize' + groupId;
  window.localStorage.setItem(key, expirationTime);
}

function getMinimization() {
  const groupId = getGroupId();
  const key = 'solvMinimize' + groupId;
  return window.localStorage.getItem(key);
}

function setMaximization() {
  const groupId = getGroupId();
  const key = 'solvMinimize' + groupId;
  window.localStorage.removeItem(key);
}

function isIdHashExpired() {
  let idHashInfo = window.localStorage.getItem('solvChatId');
  idHashInfo = JSON.parse(idHashInfo);

  if (idHashInfo == null || idHashInfo == undefined) {
    return false;
  }

  const idHashValues = Object.values(idHashInfo);
  const idHashExpired = idHashValues[1] < new Date().getTime();

  return idHashExpired;
}

function storeUserInformation(userInformation) {
  if (userInformation) {
    window.localStorage.setItem('solvChatUserInformation', userInformation);
  }
}

function getUserInformation() {
  let userInformation = window.localStorage.getItem('solvChatUserInformation');

  if (userInformation == null || userInformation == undefined) {
    return null;
  }
  return userInformation;
}

export {
  storeUserInformation,
  getUserInformation,
  isIdHashExpired,
  setGreetingView,
  getGreetingView,
  setMinimization,
  setMaximization,
  getMinimization,
};
